import React, { useState } from "react";
import PropTypes from "prop-types";
import * as Styled from "./styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faExpandAlt,
  faPlus,
  faMinus,
} from "@fortawesome/pro-solid-svg-icons";
import { Scrollbars } from "react-custom-scrollbars";
import JsonPrint from "./JsonPrint";

const Preview = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleSetExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSetCollapsed = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Styled.Container expanded={isExpanded} collapsed={isCollapsed}>
      <div className="header">
        {!isExpanded && (
          <div className="toggle" onClick={handleSetCollapsed}>
            <FontAwesomeIcon icon={isCollapsed ? faMinus : faPlus} />
          </div>
        )}
        <p>Preview</p>
        <div className="toggle" onClick={handleSetExpanded}>
          <FontAwesomeIcon icon={isExpanded ? faTimes : faExpandAlt} />
        </div>
      </div>
      <div className="content">
        <Scrollbars>{children}</Scrollbars>
      </div>
    </Styled.Container>
  );
};

Preview.propTypes = {
  children: PropTypes.node.isRequired,
};

export { JsonPrint };

export default Preview;



// WEBPACK FOOTER //
// ./src/core/admin/components/Preview/index.js